import { Height } from "@mui/icons-material";
import { LuSearch, LuChevronDown } from "@/Components/Icons/Icons.jsx";
import { alignItems, height, width } from "@mui/system";

export default {
    row1: [
        {
            column: "column1",
            columnWidth: "50%",
            rows: {
                row1: [
                    {
                        name: "kycGeneralVerficationon",
                        label: "KYC Verification on",
                        component: "dateselector",
                        width: "100%"

                    },
                ],

                row2: [
                    {
                        name: "kycGeneralValidUpTo",
                        label: "KYC Valid Upto",
                        component: "dateselector",
                        width: "100%"

                    },
                ],
                row3: [
                    {
                        name: "kycGeneralTypeofEntity",
                        label: "Type Of Entity",
                        component: "dropdown",
                        endIconName: LuChevronDown,
                        width: "90%",
                        options: [
                            {
                                label: "Company",
                                value: "Company",
                            },
                            {
                                label: "Partnership",
                                value: "Partnership",
                            },
                            {
                                label: "Trust",
                                value: "Trust",
                            },
                            {
                                label: "Limited Liability Partnership",
                                value: "Limited Liability Partnership",
                            },
                            {
                                label: "Non-Profit Organization",
                                value: "Non-Profit Organization",
                            },
                            {
                                label: "Goverment",
                                value: "Goverment",
                            },
                            {
                                label: "S-Corporation",
                                value: "S-Corporation",
                            },
                            {
                                label: "C-Corporation",
                                value: "C-Corporation",
                            },
                        ],

                    },
                    {
                        name: "Initialize",
                        label: "Initialize",
                        component: "backlink",
                        sx: {
                            mt: 4
                        }
                    },
                ],
                row4: [
                    {
                        name: "kycGeneralNameofcompany",
                        label: "Name Of Company",
                        component: "text-field",
                    },
                ],

                row5: [
                    {
                        name: "kycGeneralEntityRegNo",
                        label: "Entity Reg. NO",
                        component: "text-field",
                    },
                ],


                row6: [
                    {
                        name: "kycGeneralEntityRegDate",
                        label: "Entity Reg. Date",
                        component: "dateselector",
                        width: "100%"

                    },
                ],
                row7: [
                    {
                        name: "kycGeneralMSMERegistered",
                        label: "MSME Registered",
                        component: "dropdown",
                        endIconName: LuChevronDown,
                        options: [
                            { label: "Yes", value: "Yes" },
                            { label: "No", value: "No" },


                        ],
                    },
                ],
                row8: [
                    {
                        name: "kycGeneralMSMECategory",
                        label: "MSME Category",
                        component: "dropdown",
                        endIconName: LuChevronDown,
                        options: [
                            { label: "Micro", value: "Micro" },
                            { label: "Small", value: "Small" },
                            { label: "Medium", value: "Medium" },

                        ],

                    },
                ],
                row9: [
                    {
                        name: "kycGeneralMSMECategory",
                        label: "MSME Type",
                        component: "dropdown",
                        options: [
                            { label: "Service", value: "Service" },
                            { label: "Manufacturer", value: "Manufacturer" },
                            { label: "Trader", value: "Trader" },

                        ],

                        endIconName: LuChevronDown,

                    },
                ],
            }
        }
    ]
}